import { FC, Fragment } from 'react';
import { ComplexityDot } from './ComplexityDot';

// The complexities that together unlock the Skill Challenge, in display order. This is the `across`
// criterion from PracticeProblemsAssessmentFooter; the other path to the challenge (two correct Hard
// problems) is deliberately not advertised here. `as const` keeps the literal types the styles are
// looked up by.
const CRITERIA_COMPLEXITIES = ['1', '2', '3'] as const;

const CRITERIA_DESCRIPTION = 'Answer one Easy, one Medium, and one Hard problem correctly to try the Skill Challenge.';

const CRITERIA_LABEL = 'Try Challenge';

// Tailwind preflight is disabled in this app, so `tw-border` only paints once a style is set
// explicitly alongside it. The vertical padding also has to clear the 4px that a dot's corner badge
// pokes above the dot, or it would sit on the pill's border.
const PILL_CLASS =
  'tw-m-0 tw-flex tw-items-center tw-gap-x-2 tw-rounded-full tw-border tw-border-solid ' +
  'tw-border-neutral-100 tw-bg-neutral-0 tw-px-4 tw-py-2 tw-font-atkinson tw-text-sm ' +
  'tw-font-normal tw-text-neutral-950';

/**
 * Static legend for the Skill Challenge criteria. Every dot is drawn solved because the pill states
 * the goal rather than the student's progress — the header's track is what reports which problems
 * are actually done.
 */
export const PracticeProblemsScCriteriaExperiment: FC = () => (
  <div className="tw-flex tw-w-full tw-items-center tw-justify-end tw-py-4">
    <p className={PILL_CLASS}>
      {/* Read aloud, the dots and operators would come out as punctuation, so the visual group is
          hidden and this sentence stands in for it. */}
      <span className="tw-sr-only">{CRITERIA_DESCRIPTION}</span>

      <span className="tw-flex tw-items-center tw-gap-x-2" aria-hidden="true">
        {CRITERIA_COMPLEXITIES.map((complexity, index) => (
          <Fragment key={complexity}>
            {index > 0 && <span>+</span>}
            <ComplexityDot complexity={complexity} isComplete isAnimated={false} />
          </Fragment>
        ))}
        <span>=</span>
        <span className="tw-font-bold">{CRITERIA_LABEL}</span>
      </span>
    </p>
  </div>
);
